/* global axios */
import ApiClient from './ApiClient';

class ConversationApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  getLabels(conversationID) {
    return axios.get(`${this.url}/${conversationID}/labels`);
  }

  getWhatsAppParticipants(conversationID) {
    return axios.get(`${this.url}/${conversationID}/whatsapp_participants`, {
      timeout: 7000,
    });
  }

  openWhatsAppMention(conversationID, jid) {
    return axios.post(
      `${this.url}/${conversationID}/whatsapp_participants/conversation`,
      { jid }
    );
  }

  updateLabels(conversationID, labels) {
    return axios.post(`${this.url}/${conversationID}/labels`, { labels });
  }

  getUnreadCounts() {
    return axios.get(`${this.url}/unread_counts`);
  }
}

export default new ConversationApi();
